// Fragen-Katalog für den Mobil-Check
export const STEPS = [
    {
        id: "relation",
        title: "Ihre Rolle",
        question: "In welcher Beziehung stehen Sie zur pflegebedürftigen Person?",
        type: "single",
        options: [
            { value: "son", label: "Ich bin Sohn" },
            { value: "daughter", label: "Ich bin Tochter" },
            { value: "self", label: "Ich bin die pflegebedürftige Person selbst" },
            { value: "wife", label: "Ich bin Ehefrau" },
            { value: "husband", label: "Ich bin Ehemann" },
            { value: "partner", label: "Ich bin Ehepartner / Lebenspartner" },
            { value: "other", label: "Ich bin anderes Familienmitglied" },
        ],
    },
    {
        id: "num_children",
        title: "Kinder",
        question: "Wie viele leibliche Kinder hat die pflegebedürftige Person?",
        type: "number",
        min: 0,
        max: 12,
        showIf: (a) => ["son", "daughter"].includes(a.relation),
    },
    {
        id: "child_income_status",
        title: "Einkommen der Kinder",
        question: "Wie ist die Einkommenssituation der Kinder?",
        hint: "Maßgeblich ist § 94 SGB XII (Angehörigen-Entlastungsgesetz): Einkommen der Kinder wird grundsätzlich erst ab über 100.000 € Jahresbrutto herangezogen.",
        type: "single",
        options: [
            { value: "under_100k", label: "Kein Kind über 100.000 €" },
            { value: "over_100k", label: "Mindestens ein Kind über 100.000 €" },
            { value: "unsure", label: "Ich bin mir unsicher" },
        ],
    },
    {
        id: "assets_level",
        title: "Vermögen",
        question: "Wie hoch ist ungefähr das Vermögen der pflegebedürftigen Person?",
        type: "single",
        options: [
            { value: "none", label: "Kaum / keines" },
            { value: "low", label: "Gering" },
            { value: "medium", label: "Mittel" },
            { value: "high", label: "Höher" },
            { value: "unsure", label: "Unsicher" },
        ],
    },
    {
        id: "marital_status",
        title: "Familienstand",
        question: "Familienstand der pflegebedürftigen Person",
        type: "single",
        options: [
            { value: "single", label: "Ledig" },
            { value: "married", label: "Verheiratet" },
            { value: "divorced", label: "Geschieden" },
            { value: "widowed", label: "Verwitwet" },
            { value: "partnership", label: "Eingetragene Lebenspartnerschaft" },
        ],
    },
    {
        id: "care_grade",
        title: "Pflegegrad",
        question: "Welcher Pflegegrad liegt vor?",
        type: "single",
        options: [
            { value: "none", label: "Kein Pflegegrad" },
            { value: "pg1", label: "Pflegegrad 1" },
            { value: "pg2", label: "Pflegegrad 2" },
            { value: "pg3", label: "Pflegegrad 3" },
            { value: "pg4", label: "Pflegegrad 4" },
            { value: "pg5", label: "Pflegegrad 5" },
            { value: "unknown", label: "Unbekannt" },
        ],
    },
    {
        id: "nursing_home_status",
        title: "Heim-Status",
        question: "Lebt die Person bereits im Pflegeheim?",
        type: "single",
        options: [
            { value: "yes", label: "Ja" },
            { value: "no", label: "Nein" },
            { value: "planned", label: "In Planung" },
        ],
    },
    {
        id: "funding_ok",
        title: "Finanzierung",
        question: "Reichen Rente, laufendes Einkommen und Vermögen voraussichtlich aus?",
        type: "single",
        options: [
            { value: "yes", label: "Ja" },
            { value: "no", label: "Nein" },
            { value: "unsure", label: "Unsicher" },
        ],
    },
    {
        id: "region",
        title: "Region",
        question: "In welchem Bundesland lebt die pflegebedürftige Person?",
        type: "single",
        options: [
            { value: "baden-wuerttemberg", label: "Baden-Württemberg" },
            { value: "bayern", label: "Bayern" },
            { value: "nordrhein-westfalen", label: "Nordrhein-Westfalen" },
            { value: "hessen", label: "Hessen" },
            { value: "niedersachsen", label: "Niedersachsen" },
            { value: "rheinland-pfalz", label: "Rheinland-Pfalz" },
            { value: "berlin", label: "Berlin" },
            { value: "hamburg", label: "Hamburg" },
            { value: "sachsen", label: "Sachsen" },
            { value: "schleswig-holstein", label: "Schleswig-Holstein" },
            { value: "andere", label: "Anderes Bundesland" },
        ],
    },
    {
        id: "primary_goal",
        title: "Ihr Ziel",
        question: "Was ist Ihr Ziel?",
        type: "single",
        options: [
            { value: "orientation", label: "Erste Orientierung" },
            { value: "deep_check", label: "Detaillierte Prüfung" },
            { value: "accompaniment", label: "Begleitung bei Gesprächen / Behörden / Heim / Kasse" },
        ],
    },
];

export const REGION_COSTS = {
    "baden-wuerttemberg": { label: "Baden-Württemberg", eigenanteil_total: 3200 },
    bayern: { label: "Bayern", eigenanteil_total: 2800 },
    "nordrhein-westfalen": { label: "Nordrhein-Westfalen", eigenanteil_total: 3100 },
    hessen: { label: "Hessen", eigenanteil_total: 2900 },
    niedersachsen: { label: "Niedersachsen", eigenanteil_total: 2600 },
    "rheinland-pfalz": { label: "Rheinland-Pfalz", eigenanteil_total: 2700 },
    berlin: { label: "Berlin", eigenanteil_total: 2800 },
    hamburg: { label: "Hamburg", eigenanteil_total: 2900 },
    sachsen: { label: "Sachsen", eigenanteil_total: 2400 },
    "schleswig-holstein": { label: "Schleswig-Holstein", eigenanteil_total: 2700 },
    andere: { label: "Ihr Bundesland", eigenanteil_total: 2800 },
};
